export default __webpack_public_path__ + "static/media/icon-system.746bc54c.svg";